import { render, staticRenderFns } from "./BaseRecharge.vue?vue&type=template&id=fb90854a&scoped=true&"
import script from "./BaseRecharge.vue?vue&type=script&lang=js&"
export * from "./BaseRecharge.vue?vue&type=script&lang=js&"
import style0 from "./BaseRecharge.vue?vue&type=style&index=0&id=fb90854a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb90854a",
  null
  
)

export default component.exports